module.exports = {"Administración de proveedores":"Administración de proveedores","Listado de proveedores":"Listado de proveedores","Nombre":"Nombre","Ver proveedor":"Ver proveedor","Editar proveedor":"Editar proveedor","Nuevo proveedor":"Nuevo proveedor","Tipo de documento":"Tipo de documento","Número de documento":"Número de documento","Tipo de persona":"Tipo de persona","Dirección":"Dirección","Teléfono":"Teléfono","Correo electrónico":"Correo electrónico"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/proveedores/es.json
// module id = 1117
// module chunks = 0